import { useCommand } from 'core/use-cases/utilities';

import { actions } from '../slice';

import type { Catalog } from 'core/domains';

/**
 * Exports catalog dispatch commands.
 *
 */
export function useCatalogCommand() {
  const { dispatchCommand } = useCommand();

  /**
   * Clean up page from store to avoid memory leaks
   *
   */
  function cleanCatalog() {
    dispatchCommand(actions.catalogCleanUp());
  }

  /**
   * Gets catalog
   *
   */
  function getCatalog(queryOptions: Catalog['queryOptions']) {
    dispatchCommand(actions.catalogFetch.request(queryOptions));
  }

  /**
   * Search next page in catalog
   *
   */
  function getNextPage(queryOptions: Catalog['queryOptions']) {
    dispatchCommand(actions.catalogNextPageFetch.request(queryOptions));
  }

  return {
    cleanCatalog,
    getCatalog,
    getNextPage,
  };
}
